import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root',
})
export class TranslationsService implements TranslateLoader {
  constructor(private appService: AppService) {}
  getTranslation(lang: string): Observable<any> {
    return this.appService.getTranslations(lang);
  }
}
